import { Modal } from "tailwindcss-stimulus-components";

export default class ContactModal extends Modal {
  static targets = ["dialog", "frame"];
  static values = {
    contactableType: String,
    contactableId: String
  }

  connect() {
    super.connect();
    this.handleEscapeBound = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close(event);
      }
    };
    if (this.hasDialogTarget) {
      this.dialogTarget.addEventListener('keydown', this.handleEscapeBound);
    }
  }

  disconnect() {
    if (this.hasDialogTarget) {
      this.dialogTarget.removeEventListener('keydown', this.handleEscapeBound);
    }
    super.disconnect();
  }

  open(event) {
    super.open(event);

    // Get contact ID from the clicked button (for edit) or null (for new)
    const contactId = this.getContactIdFromEvent(event);
    this.loadContent(contactId);

    // Focus dialog for keyboard events
    if (this.hasDialogTarget) {
      this.dialogTarget.focus();
    }
  }

  getContactIdFromEvent(event) {
    if (!event?.target) return null;
    let contactId = event.target.dataset.contactModalContactIdValue;
    if (!contactId) {
      const button = event.target.closest('[data-contact-modal-contact-id-value]');
      contactId = button ? button.dataset.contactModalContactIdValue : null;
    }
    return contactId;
  }

  close(event) {
    // Prevent default close behavior so a page refresh doesn't happen
    if (event) {
      event.preventDefault();
    }
    super.close(event);
  }

  loadContent(contactId) {
    if (this.hasFrameTarget && this.hasContactableTypeValue && this.hasContactableIdValue) {
      let url;
      if (contactId) {
        // Edit existing contact
        url = `/contacts/${contactId}/edit?modal=true`;
      } else {
        // New contact - use the appropriate param key based on contactable type
        const paramKey = this.contactableTypeValue.replace(/([A-Z])/g, '_$1').toLowerCase().replace(/^_/, '') + '_id';
        url = `/contacts/new?${paramKey}=${this.contactableIdValue}&modal=true`;
      }
      this.frameTarget.setAttribute('src', url);
    }
  }
}
